import axios from 'axios';
import React, { useState } from 'react';
import $ from 'jquery';
import * as Yup from 'yup';
import * as APIS from '../../Config/Apis';
import { getToken } from '../../Utils/Common';
import { useComponentDidMount, withRouter } from '../../Utils/Component';
import { fetchBuses, fetchCompanies } from '../../Utils/DropdownsNew';
import { useFormik } from 'formik';
import AlertDismissError from "../Layouts/AlertDismissError";
import { DatePicker } from 'antd';
import moment from 'moment';
import { SearchOutlined } from '@ant-design/icons';
import { red, volcano, orange, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta, grey } from '@ant-design/colors';

import { Layout, Breadcrumb, PageHeader, Collapse, Row, Col, Button, Select, Table, Input, Space, Tag } from "antd";
import AlertError from '../Layouts/AlertError';
import { useNavigate } from 'react-router-dom';
const { Content, Footer } = Layout;
const { Panel } = Collapse;
const { Option } = Select;

function Schedules() {
    const token = getToken();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const formik = useFormik({
        initialValues: {
            start_date: moment("00:00:00", "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
            end_date: moment("23:59:59", "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
            company_id: '',
            bus_id: '',
        },
        validationSchema: Yup.object({
            start_date: Yup.string().required(),
            end_date: Yup.string().required(),
        }),
        onSubmit: values => {
            console.log(values);
            setError(null);
            setLoading(true);
            setTableError(null);
            if (values.company_id == '-1') {
                values.company_id = '';
            }
            if (values.bus_id == '-1') {
                values.bus_id = '';
            }
            let params = {
                start_date: values.start_date,
                end_date: values.end_date,
                company_id: values.company_id,
                bus_id: values.bus_id
            };
            let queryStringFilter = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            console.log(queryStringFilter);
            setLoading(false);

            setFiltersQuery(queryStringFilter);
            // clearFilters();
            setTableDraw(1);
            params = { draw: 1, start: 0, length: 10 };
            let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            queryString += "&" + queryStringFilter + columnsQuery;
            getTableData(queryString);
        },
    });

    const [dropdownCompanies, setDropdownCompanies] = useState(null);
    const [dropdownCompaniesLoading, setDropdownCompaniesLoading] = useState(true);
    const [dropdownBuses, setDropdownBuses] = useState(null);
    const [dropdownBusesLoading, setDropdownBusesLoading] = useState(true);
    useComponentDidMount(() => {
        fetchCompanies('100%', window, token, '#select_company_id', function (data) {
            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
            setDropdownCompanies(items);
            setDropdownCompaniesLoading(false);
        });
        fetchBuses('100%', window, token, '#select_bus_id', function (data) {
            let items = data.map(d => <Option key={d.value}>{d.label}</Option>);
            setDropdownBuses(items);
            setDropdownBusesLoading(false)
        });
        const params = { draw: 1, start: 0, length: 10 };
        const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        getTableData(queryString);
    });

    const [filtersQuery, setFiltersQuery] = useState('');
    const [columnsQuery, setColumnsQuery] = useState('');
    const [tableDraw, setTableDraw] = useState(1);
    const [tableData, setTableData] = useState(false);
    const [tableError, setTableError] = useState(null);
    const [tableTotalCount, setTableTotalCount] = useState(0);
    const [tableFilterCount, setTableFilterCount] = useState(0);
    const [tableFilterValues, setTableFilterValues] = useState(null);
    const clearFilters = () => {
        setTableFilterValues(null);
    };
    const searchColumnText = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    // onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    onPressEnter={() => { confirm() }}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnDate = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                {
                    selectedKeys[0] ? <DatePicker
                        style={{ marginBottom: 8, display: 'block' }}
                        defaultValue={moment(selectedKeys[0], "YYYY-MM-DD")}
                        onChange={(moment) => {
                            try {
                                setSelectedKeys([moment.format("YYYY-MM-DD")]);
                            } catch (e) {
                                setSelectedKeys([]);
                            }
                        }}
                    /> : <DatePicker
                        style={{ marginBottom: 8, display: 'block' }}
                        onChange={(moment) => {
                            try {
                                setSelectedKeys([moment.format("YYYY-MM-DD")]);
                            } catch (e) {
                                setSelectedKeys([]);
                            }
                        }}
                    />
                }
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnSelectStatus = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select defaultValue={selectedKeys[0]} style={{ marginBottom: 8, display: 'block' }} onChange={value => setSelectedKeys(value ? [value] : [])}>
                    <Option value="-1">All</Option>
                    <Option value="3">Pending</Option>
                    <Option value="4">Upcoming</Option>
                    <Option value="1">Live</Option>
                    <Option value="2">Completed</Option>
                    <Option value="0">Cancelled</Option>
                </Select>
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const tableColumns = [
        "schedule_id", // 0
        "company_name", // 1
        "route_name", // 2
        "bus_plate_number", // 3
        "start_time", // 4
        "end_time", // 5
        "no_of_seats_available", // 6
        "no_of_seats_reserved", // 7
        "no_of_tickets_confirmed", // 8
        "no_of_tickets_confirmed", // 9
        "no_of_tickets_validated", // 10
        "total_amount", // 11
        "schedule_status_label", // 12
    ]
    const tableColumnsHead = [
        { dataIndex: tableColumns[0], filteredValue: tableFilterValues && tableFilterValues[tableColumns[0]] ? tableFilterValues[tableColumns[0]] : null, ...searchColumnText(tableColumns[0]), title: "Trip Id", render: value => <a onClick={goToDetails.bind(this, value)}>{value}</a>, },
        { dataIndex: tableColumns[1], filteredValue: tableFilterValues && tableFilterValues[tableColumns[1]] ? tableFilterValues[tableColumns[1]] : null, ...searchColumnText(tableColumns[1]), title: "Company" },
        { dataIndex: tableColumns[2], filteredValue: tableFilterValues && tableFilterValues[tableColumns[2]] ? tableFilterValues[tableColumns[2]] : null, ...searchColumnText(tableColumns[2]), title: "Route" },
        { dataIndex: tableColumns[3], filteredValue: tableFilterValues && tableFilterValues[tableColumns[3]] ? tableFilterValues[tableColumns[3]] : null, ...searchColumnText(tableColumns[3]), title: "Bus" },
        { dataIndex: tableColumns[4], filteredValue: tableFilterValues && tableFilterValues[tableColumns[4]] ? tableFilterValues[tableColumns[4]] : null, ...searchColumnDate(tableColumns[4]), title: "Start Time" },
        { dataIndex: tableColumns[5], filteredValue: tableFilterValues && tableFilterValues[tableColumns[5]] ? tableFilterValues[tableColumns[5]] : null, ...searchColumnDate(tableColumns[5]), title: "End Time" },
        { dataIndex: tableColumns[6], filteredValue: tableFilterValues && tableFilterValues[tableColumns[6]] ? tableFilterValues[tableColumns[6]] : null, ...searchColumnText(tableColumns[6]), title: "Seats Available" },
        { dataIndex: tableColumns[7], filteredValue: tableFilterValues && tableFilterValues[tableColumns[7]] ? tableFilterValues[tableColumns[7]] : null, ...searchColumnText(tableColumns[7]), title: "Seats Reserved" },
        { dataIndex: tableColumns[8], filteredValue: tableFilterValues && tableFilterValues[tableColumns[8]] ? tableFilterValues[tableColumns[8]] : null, ...searchColumnText(tableColumns[8]), title: "Seats Booked" },
        { dataIndex: tableColumns[9], filteredValue: tableFilterValues && tableFilterValues[tableColumns[9]] ? tableFilterValues[tableColumns[9]] : null, ...searchColumnText(tableColumns[9]), title: "Seats Confirmed" },
        { dataIndex: tableColumns[10], filteredValue: tableFilterValues && tableFilterValues[tableColumns[10]] ? tableFilterValues[tableColumns[10]] : null, ...searchColumnText(tableColumns[10]), title: "Seats Validated" },
        { dataIndex: tableColumns[11], filteredValue: tableFilterValues && tableFilterValues[tableColumns[11]] ? tableFilterValues[tableColumns[11]] : null, ...searchColumnText(tableColumns[11]), title: "Total Amount" },
        {
            dataIndex: tableColumns[12], filteredValue: tableFilterValues && tableFilterValues[tableColumns[12]] ? tableFilterValues[tableColumns[12]] : null, ...searchColumnSelectStatus(tableColumns[12]), title: "Status",
            render: value => {
                let color = grey.primary;
                if (value === 'Pending') {
                    color = red.primary;
                }
                if (value === 'Upcoming') {
                    color = purple.primary;
                }
                if (value === 'Live') {
                    color = blue.primary;
                }
                if (value === 'Completed') {
                    color = green.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value}
                    </Tag>
                );
            }
        },
    ];

    const tableHandleChange = (pagination, filters, sorter) => {
        console.log(filters);
        setTableFilterValues(filters);
        let columnsQuery = "";
        let index = 0
        tableColumns.forEach(column => {
            if (filters[column]) {
                let column_data = 'columns[' + index + '][data]=' + column;
                let column_name = 'columns[' + index + '][name]=';
                let column_orderable = 'columns[' + index + '][orderable]=false';
                let column_searchable = 'columns[' + index + '][searchable]=true';
                let column_search_value = 'columns[' + index + '][search][value]=' + filters[column][0];
                let column_search_regex = 'columns[' + index + '][search][regex]=false';
                columnsQuery += "&" + column_data;
                columnsQuery += "&" + column_name;
                columnsQuery += "&" + column_orderable;
                columnsQuery += "&" + column_searchable;
                columnsQuery += "&" + column_search_value;
                columnsQuery += "&" + column_search_regex;
            }
            index++;
        });
        setColumnsQuery(columnsQuery);
        const offset = pagination.current * pagination.pageSize - pagination.pageSize;
        const limit = pagination.pageSize;
        setTableDraw(tableDraw + 1);
        const params = { draw: tableDraw, start: offset, length: limit };
        let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        queryString += "&" + filtersQuery + columnsQuery;
        getTableData(queryString);
    };

    const getTableData = (queryString) => {
        console.log(queryString);
        setLoading(true);
        setTableError(null);
        const suffix = queryString === null ? "" : "?" + queryString;
        const config = {
            "url": APIS.FULL_SCHEDULES + suffix,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                // console.log(JSON.stringify(response.data));
                console.log(JSON.stringify(response.data.data.datatable.recordsTotal));
                console.log(JSON.stringify(response.data.data.datatable.recordsFiltered));
                setLoading(false);
                setTableTotalCount(response.data.data.datatable.recordsTotal);
                setTableFilterCount(response.data.data.datatable.recordsFiltered);
                setTableData(response.data.data.datatable.data);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    let exportCsv = () => {
        let query = "";
        if (filtersQuery != "") {
            query += filtersQuery;
        }
        if (columnsQuery != "") {
            if (query == "") {
                query += columnsQuery.substring(1);
            } else {
                query += columnsQuery;
            }
        }
        const suffix = query === null ? "" : "?" + query;
        var config = {
            method: 'get',
            url: APIS.EXPORT_FULL_SCHEDULES + suffix,
            headers: Object.assign(APIS.HEADERS),
        };
        // console.log(config);
        setLoading(true);
        setTableError(null);
        axios(config)
            .then(function (response) {
                // console.log(JSON.stringify(response.data));
                let filename = response.data.data.filename;
                let filepath = response.data.data.filepath;
                let fileUrl = APIS.APP_DOWNLOAD_FILE + "?filename=" + filename + "&filepath=" + filepath
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                $.ajax({
                    url: fileUrl,
                    type: 'get',
                    dataType: 'binary',
                    headers: Object.assign(APIS.HEADERS),
                    processData: false,
                    success: function (blob) {
                        var windowUrl = window.URL || window.webkitURL;
                        var url = windowUrl.createObjectURL(blob);
                        var anchor = document.createElement('a');
                        anchor.prop('href', url);
                        anchor.prop('download', filename);
                        anchor.get(0).click();
                        windowUrl.revokeObjectURL(url);
                    }
                });
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    }

    const exportButton = () => (
        <Button type="primary" loading={loading} onClick={exportCsv.bind(this)}>Export</Button>
    );

    const goToDetails = (id) => {
        navigate('/full-schedules/'+id);
    }

    return (
        <Layout>
            <Content className="site-layout" style={{ padding: "0 15px" }}>
                <Breadcrumb style={{ margin: "5px 0" }}>
                    <Breadcrumb.Item><a>Home</a></Breadcrumb.Item>
                    <Breadcrumb.Item>Schedules</Breadcrumb.Item>
                </Breadcrumb>
                <div className="site-layout-background" style={{ padding: 0, minHeight: 380 }}>
                    <PageHeader className="site-page-header" title="History Schedules" extra={exportButton()} />
                    <div style={{ padding: 10 }}>
                        <>
                            {tableError && <div style={{ marginBottom: "10px" }}><AlertError title="Error" message={tableError} /></div>}
                            <Collapse accordion style={{ marginBottom: "10px" }}>
                                <Panel header="Filters" key="1">
                                    <form noValidate="novalidate" action="#" onSubmit={formik.handleSubmit}>
                                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]}>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Start Datetime</label>
                                                <DatePicker
                                                    name="start_date"
                                                    showTime defaultValue={moment("00:00:00", "HH:mm:ss")}
                                                    onOk={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("start_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("start_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                    onChange={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("start_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("start_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                />
                                                {formik.touched.start_date && formik.errors.start_date ? (<div className="ant-form-item-explain-error">{formik.errors.start_date}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>End Datetime</label>
                                                <DatePicker
                                                    name="start_date"
                                                    showTime defaultValue={moment("23:59:59", "HH:mm:ss")}
                                                    onOk={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("end_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("end_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                    onChange={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("end_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("end_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                />
                                                {formik.touched.end_date && formik.errors.end_date ? (<div className="ant-form-item-explain-error">{formik.errors.end_date}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Company</label><br />
                                                <Select name="company_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownCompaniesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("company_id", value, false); }}>
                                                    {dropdownCompanies}
                                                </Select>
                                                {formik.touched.company_id && formik.errors.company_id ? (<div className="ant-form-item-explain-error">{formik.errors.company_id}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Bus</label><br />
                                                <Select name="bus_id" style={{ width: "100%" }} allowClear showSearch loading={dropdownBusesLoading}
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => { formik.setFieldValue("bus_id", value, false); }}>
                                                    {dropdownBuses}
                                                </Select>
                                                {formik.touched.bus_id && formik.errors.bus_id ? (<div className="ant-form-item-explain-error">{formik.errors.bus_id}</div>) : null}
                                            </Col>
                                        </Row>
                                        {error && <div style={{ marginTop: "10px" }}><AlertDismissError title="Error" message={error} /></div>}
                                        <Button style={{ marginTop: "10px" }} type="primary" htmlType="submit" size="large" block loading={loading}>Submit</Button>
                                    </form>
                                </Panel>
                            </Collapse>
                            <Table
                                rowKey={tableColumns[0]}
                                columns={tableColumnsHead}
                                dataSource={tableData || []}
                                loading={loading}
                                title={null}
                                footer={null}
                                bordered={true}
                                size={'small'}
                                scroll={{ x: true }}
                                onChange={tableHandleChange}
                                pagination={{
                                    size: 'default',
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                    total: tableFilterCount,
                                    showTotal: (total, range) => {
                                        if (total == tableTotalCount) {
                                            return `${range[0]}-${range[1]} of ${total} items`;
                                        } else {
                                            return `${range[0]}-${range[1]} of ${total} items (filtered from ${tableTotalCount} total items)`;
                                        }
                                    },
                                }}
                            />
                        </>
                    </div>
                </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>
                Copyright © 2022 AC GROUP | Tap&Go Ticketing v7.0.0
            </Footer>
        </Layout>
    )
}

export default withRouter(Schedules);